import React from 'react';
import { useField } from 'formik';
import { Input } from 'reactstrap';
import FieldWrapper from './FieldWrapper';

const FormikInput = (props) => {
  const {
    name,
    label,
    className,
    fieldClassName,
    inputClassName = '',
    type = 'text',
    icon,
    ...restProps
  } = props;
  const [field, meta] = useField(name);
  const { value = '', ...restField } = field || {}

  return (
    <FieldWrapper
      name={name}
      label={label}
      fieldClassName={fieldClassName}
      className={className}
    >
      {!!icon && <div className="field-icon">{icon}</div>}
      <Input
        name={name}
        type={type}
        invalid={meta?.touched && !!meta?.error}
        className={inputClassName}
        value={value}
        {...restProps}
        {...restField}
      />
    </FieldWrapper>
  );
};

export default FormikInput;
